import React, { useState,useEffect } from 'react';
import { Container,Card,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import './focusUtils';
const ResearchGallery = () => 
{
    const[isLoading, setLoading] = useState(true);
    const[Glimpses,setGlimpses]=useState([]);
    useEffect(()=>
    {
        const AlumniGlimpses = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL + "upload/details/0/15/siteGlimpses");
                const result = await response.json();
                setGlimpses(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('Alumni Glimpses : Result',result); }
            } catch (error) 
            {
                console.error('Alumni Glimpses : Error', error.message);
                setLoading(false);
            }
        };
        AlumniGlimpses();
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();   
    },[])
    const settings = {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: false,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    return (
        <section className="hp-department" style={{backgroundImage: `url(${global.config.uploadPath+'1034662324.png'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat"}}>
            <Container className="py-md-5 py-4 text-center">
                {isLoading ? (
                <div className="slider-container px-4 py-3" data-aos="flip-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        {[...Array(5)].map((_,index)=>(
                        <div className='p-3' key={index}>
                            <Card className='text-center card-custom'>
                                <Placeholder xs={12} className="card-img" style={{minHeight:"180px"}} />
                            </Card>
                        </div>
                        ))}
                    </Slider>
                </div>
                ) : (
                <div className="slider-container px-4 py-3" data-aos="flip-up" data-aos-duration="1000">
                    <Slider {...settings}>
                        {Glimpses.map((sg, index)=>(
                            <div className='p-3 h-100' key={index}>
                                <Card className='text-center card-custom'>
                                    <Card.Img className="img-fluid" src={global.config.uploadPath+sg.up_fname+sg.up_ext} width={260} height={160} alt={sg.up_oname} loading="lazy" />
                                </Card>
                            </div>
                        ))}
                    </Slider>
                </div>
                )}
            </Container>
        </section>
    );    
}
export default ResearchGallery;